import validate from "/app/node_modules/.pnpm/nuxt@3.3.3_@types+node@18.19.3_rollup@4.9.0_sass@1.69.5/node_modules/nuxt/dist/pages/runtime/validate.js";
import block_45route_45global from "/app/src/client/middleware/block-route.global.ts";
export const globalMiddleware = [
  validate,
  block_45route_45global
]
export const namedMiddleware = {}